import React from "react";
import IconBox from "./IconBox";
import {useTranslation} from "react-i18next";

const SearchBox = ({spacialClass, value, changeFunction}) => {
  const {t} = useTranslation()

  return (
    <div className={`filter_box has_border ${spacialClass}`}>
      <IconBox iconName="searchIcon" specialClass="border_shadow large_icon"/>
      <div className="filter_field_box">
        <input
          type="text"
          className="filter_field field_shadow"
          placeholder={t('Organizational.Settings.Items.Search.Bar')}
          value={value}
          onChange={(e) => changeFunction && changeFunction(e.target.value)}
        />
      </div>
    </div>
  );
};

export default SearchBox;
